import Shopify from './src/shopify';


var __SHOPIFY = false;
$(document).ready( ()=>{

	const s = new Shopify({

	});


	console.log( window.__SHOPIFY );

	window.__SHOPIFY = s;

	console.log( window.__SHOPIFY );
});